import React from 'react';

const ForbiddenError: React.FC = () => {
    return <h1>You cannot add policies</h1>;
};

export default ForbiddenError;
